import axios from 'axios';

const api_base_url =
    process.env.NODE_ENV === 'development'
        ? 'http://localhost:8008'
        : '/api';

const api = axios.create({
    baseURL: api_base_url,
});

// Helpers de token
const setToken = (token) => {
    localStorage.setItem('accessToken', token);
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
};

const clearToken = () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    delete api.defaults.headers.common['Authorization'];
};

const getAccessToken = () => {
    return localStorage.getItem('accessToken');
};

const getRefreshToken = () => {
    return localStorage.getItem('refreshToken');
};

// Inicializa o token se já estiver salvo
const token = getAccessToken();
if (token) {
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}

// Interceptor para adicionar token
api.interceptors.request.use((config) => {
    const token = getAccessToken();
    if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
});

// Interceptor de resposta para fazer refresh automático
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
    failedQueue.forEach((prom) => {
        if (error) {
            prom.reject(error);
        } else {
            prom.resolve(token);
        }
    });

    failedQueue = [];
};

api.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        // 👇 Ignora tentativa de refresh para requisições com esta flag
        if (originalRequest?.skipAuthRefresh) {
            return Promise.reject(error);
        }

        if (error.response?.status === 401 && !originalRequest._retry) {
            if (isRefreshing) {
                return new Promise(function (resolve, reject) {
                    failedQueue.push({ resolve, reject });
                })
                    .then((token) => {
                        originalRequest.headers['Authorization'] = 'Bearer ' + token;
                        return api(originalRequest);
                    })
                    .catch((err) => Promise.reject(err));
            }

            originalRequest._retry = true;
            isRefreshing = true;

            const refreshToken = getRefreshToken();

            if (!refreshToken) {
                clearToken();
                window.location.href = '/Login';
                return Promise.reject(error);
            }

            try {
                const response = await axios.post(`${api_base_url}/refreshToken`, { refreshToken });

                if (response.data?.auth) {
                    const newToken = response.data.token;
                    setToken(newToken);
                    processQueue(null, newToken);

                    originalRequest.headers['Authorization'] = 'Bearer ' + newToken;
                    return api(originalRequest);
                } else {
                    processQueue(new Error('Refresh token inválido'), null);
                    clearToken();
                    window.location.href = '/Login';
                }
            } catch (err) {
                processQueue(err, null);
                clearToken();
                window.location.href = '/Login';
                return Promise.reject(err);
            } finally {
                isRefreshing = false;
            }
        }

        return Promise.reject(error);
    }
);


export { setToken, clearToken };
export default api;
